export default "__VITE_ASSET__CCc45CTD__"